import { roboto } from '@/lib/fonts'
import { Language } from '@/lib/interfaces/interfaces'
import { LoadingButton } from '@mui/lab'
import { Button, Typography } from '@mui/material'
import { ArrowLeft, ShoppingCartIcon, Trash2 } from 'lucide-react'

interface Props {
  total: number
  whatToShow: 'cartList' | 'shippingDetails'
  handleSubmitClick: () => void
  handleSecondaryBtnClick: () => void
  nItems: number
  deliveryFee: number
  minOrder: number
  loading: boolean
  language: Language
}

// Objeto de traducciones para cada idioma
const translations = {
  es: {
    total: 'Total:',
    shippingFee: '+ gastos de envío',
    primaryMinOrder: 'Pedido mínimo',
    continue: 'Continuar',
    submitOrder: 'Realizar pedido',
    emptyCart: 'Vaciar carrito',
    back: 'Volver'
  },
  en: {
    total: 'Total:',
    shippingFee: '+ shipping fee',
    primaryMinOrder: 'Minimum order',
    continue: 'Continue',
    submitOrder: 'Place order',
    emptyCart: 'Empty cart',
    back: 'Back'
  },
  fr: {
    total: 'Total :',
    shippingFee: '+ frais de livraison',
    primaryMinOrder: 'Commande minimale',
    continue: 'Continuer',
    submitOrder: 'Passer la commande',
    emptyCart: 'Vider le panier',
    back: 'Retour'
  }
}

const ActionButtons = ({
  handleSecondaryBtnClick,
  handleSubmitClick,
  total,
  whatToShow,
  nItems,
  deliveryFee,
  minOrder,
  loading,
  language
}: Props) => {
  const texts = translations[language] || translations.es

  let primaryBtnText = ''
  if (whatToShow === 'cartList') {
    if (total < minOrder) {
      primaryBtnText = `${texts.primaryMinOrder} ${minOrder.toFixed(2)}€`
    } else {
      primaryBtnText = texts.continue
    }
  }

  return (
    <div className='orderingCart__container__footer'>
      <div className='total'>
        <Typography variant='h6'>{texts.total}</Typography>
        <Typography variant='h6'>{total.toFixed(2)}€</Typography>
      </div>
      <div className='shipping-fee'>
        <span style={roboto.style}>{texts.shippingFee}</span>
        <span style={roboto.style}>{deliveryFee.toFixed(2)}€</span>
      </div>
      <div className='actionButtons'>
        <LoadingButton
          variant='contained'
          color='primary'
          fullWidth
          loading={loading}
          disabled={nItems === 0 || total < minOrder || loading}
          startIcon={whatToShow === 'shippingDetails' ? <ShoppingCartIcon size={20} /> : null}
          className='button'
          onClick={handleSubmitClick}
        >
          <span>
            {whatToShow === 'cartList' ? primaryBtnText : texts.submitOrder}
          </span>
        </LoadingButton>
        <Button
          variant='outlined'
          color='secondary'
          fullWidth
          onClick={handleSecondaryBtnClick}
          startIcon={whatToShow === 'cartList' ? <Trash2 size={20} /> : <ArrowLeft size={20} />}
          className='button'
        >
          {whatToShow === 'cartList' ? texts.emptyCart : texts.back}
        </Button>
      </div>
    </div>
  )
}

export default ActionButtons
